// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ds-2";
export var aiChatCartContainerExit = "_ds-4";
export var aiChatContainerLarge = "_ds-0";
export var aiChatContainerSmall = "_ds-1";
export var aiChatIcon = "_ds-6";
export var slideInFromRight = "_ds-3";
export var slideOutToRight = "_ds-5";